var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.755 5h14.49C25.742 5 27 6.231 27 8.704v14.591C27 25.77 25.742 27 23.245 27H8.755C6.243 27 5 25.757 5 23.295V8.705C5 6.242 6.243 5 8.755 5zm8.096 6.324c0-.496-.366-.824-.851-.824-.496 0-.85.328-.85.824l.06 7.715-2.39-2.63a.789.789 0 0 0-.594-.248.803.803 0 0 0-.82.81c0 .236.087.43.238.582l3.699 3.699c.216.215.41.313.658.313.237 0 .42-.087.647-.313l3.71-3.7c.15-.15.215-.345.215-.582a.794.794 0 0 0-.809-.809.85.85 0 0 0-.593.249l-2.38 2.629z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSquare);
export default __webpack_public_path__ + "static/media/Arrow_Down-Square.51a9973ac955fc490a0fa004fb970dad.svg";
export { ForwardRef as ReactComponent };